import { Group } from '@mantine/core';
import DateRangePicker from './DateRangePicker/DateRangePicker';
import MetricsExportButton from './MetricsExportButton';

/**
 * MetricsSelector component that wraps DateRangePicker and MetricsExportButton.
 *
 * Props:
 * - startDate: string - ISO date "YYYY-MM-DD"
 * - endDate: string - ISO date "YYYY-MM-DD"
 * - setStartDate: (date: string) => void
 * - setEndDate: (date: string) => void
 * - setDateRange: (start: string, end: string) => void (optional) - for atomic updates
 * - maxDate: string (optional) - ISO date "YYYY-MM-DD"
 * - scope: string (optional) - entity type for export
 * - id: number (optional) - entity id for export
 */
const MetricsSelector = ({ id, startDate, endDate, setStartDate, setEndDate, setDateRange, scope, maxDate }) => {
  if (!startDate || !endDate) {
    return null;
  }
  return (
    <Group gap="sm">
      <div data-tour="metricsSelector">
        <DateRangePicker
          preSetRanges={true}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          setDateRange={setDateRange}
          maxDate={maxDate}
        />
      </div>
      {scope && <MetricsExportButton id={id} scope={scope} periodStart={startDate} periodEnd={endDate} />}
    </Group>
  );
};

export default MetricsSelector;
